import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
export class UsedRegisterCode extends AutoEncoder {
    id;
    organizationName;
    createdAt;
    creditValue = null;
}
__decorate([
    field({ decoder: StringDecoder })
], UsedRegisterCode.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UsedRegisterCode.prototype, "organizationName", void 0);
__decorate([
    field({ decoder: DateDecoder })
], UsedRegisterCode.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], UsedRegisterCode.prototype, "creditValue", void 0);
export class RegisterCodeStatus extends AutoEncoder {
    code;
    usedCodes = [];
    value = 0;
    invoiceValue = null;
}
__decorate([
    field({ decoder: StringDecoder })
], RegisterCodeStatus.prototype, "code", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(UsedRegisterCode) })
], RegisterCodeStatus.prototype, "usedCodes", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 231 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], RegisterCodeStatus.prototype, "value", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 231 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], RegisterCodeStatus.prototype, "invoiceValue", void 0);
export class RegisterCode extends AutoEncoder {
    code;
    description;
    customMessage = null;
    organizationName;
    value = 0;
}
__decorate([
    field({ decoder: StringDecoder })
], RegisterCode.prototype, "code", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegisterCode.prototype, "description", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], RegisterCode.prototype, "customMessage", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], RegisterCode.prototype, "organizationName", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], RegisterCode.prototype, "value", void 0);
//# sourceMappingURL=RegisterCodeStatus.js.map